export default __webpack_public_path__ + "static/media/evolution.9a677502.svg";